import { SelectionPath } from "../game/selectionPath";
import { audio } from "../main.js";
import { Sounds } from "../audio/sounds.js";

import * as svg from "./svg.js";
import * as grid from "./grid.js";

const gridGeometry = () => grid.getGridGeometry();
let path = new SelectionPath();
let gameClient;

export function setCopyLink() {
  const newGame = document.getElementById("copyLink");
  newGame.addEventListener("click", async () => {
    const matchId = gameClient.matchId;
    const copyLink = new URL("https://wordhunt.nathangillispie.work");
    copyLink.searchParams.set("invite", matchId);
    try {
      await navigator.share({ title: "WORD HUNT", url: copyLink.toString() });
    } catch (err) {
      try {
        await navigator.clipboard.writeText(copyLink.toString());
        newGame.textContent = "Copied!";
        setTimeout(() => {
          newGame.textContent = "Copy link";
        }, 2000);
      } catch (err2) {
        console.error(err, err2);
      }
    }
  });
}

function createStartMatchButton() {
  const startGame = document.getElementById("startGame");
  startGame.classList.remove("ready");
  startGame.classList.remove("waitingOnOpponent");
  startGame.textContent = "Begin";

  startGame.addEventListener("click", () => {
    gameClient.startMatch();
  });
}

export function createWaitingScreen(matchId) {
  const app = document.getElementById("app");
  app.innerHTML = `
    <div id="waitingContainer" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
      <button id="startGame" class="animateIn">TEST</button>
      <br>
      <button id="copyLink" style="visibility:hidden;" class="animateIn">Copy link</button>
    </div>
  `;

  const startGame = document.getElementById("startGame");
  if (gameClient.player === "player1") {
    document.getElementById("copyLink").style.visibility = "unset";
    setCopyLink();
    startGame.classList.add("waitingOnOpponent");
    startGame.textContent = "Waiting on Opponent...";
    // Callback is executed when player2 has joined and is ready
    gameClient.onReadyPlayer1(() => {
      createStartMatchButton();
    });
  } else { // we are player2
    startGame.classList.add("ready");
    startGame.textContent = "I'm Ready!";
    startGame.addEventListener("click", async () => {
      gameClient.joinMatch(matchId).then(() => {
        startGame.classList.remove("ready");
        startGame.classList.add("waitingOnOpponent");
        startGame.textContent = "Waiting to start...";
      });
      // set up listener for if match starts, then gameClient.startMatch();
    });
  }

}

export function createWelcomeScreen() {
  const app = document.getElementById("app");
  app.innerHTML = `
    <div id="welcomeContainer" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
      <button id="newGame" class="animateIn">New Game</button>
      <br>
      <button id="howToButton" class="animateIn">How To Play</button>
    </div>
  `;

  const newGame = document.getElementById("newGame");
  newGame.addEventListener("click", async () => {
    gameClient.createMatch();
    createWaitingScreen();
  });

  document.getElementById("howToButton").addEventListener("click", () => { 
    document.querySelector("dialog").showModal();
  });
}

export function initializeUI(client) {
  gameClient = client;

  // Animate out the loading infinitys symbol
  const infinityEl = document.getElementById("loading");
  infinityEl.classList.add("animateOut");
  setTimeout(() => {
    infinityEl.remove()
  }, 1000);
}

/**
 *  Defined after grid is created because we need to know the size of the grid.
 */
let getCellFromPointerEvent;

/**
 *  Adds/removes an animated CSS class to cell on selection/deselection
 */
export function selectCellByIndex(index) {
  const myCell = document.getElementById("cell-"+index);
  myCell.classList.add("selected");
}

export function deselectCellByIndex(index) {
  const myCell = document.getElementById("cell-"+index);
  myCell.classList.remove("selected");
}

export function updateScore(score = 0) {
  // TODO: do more css here?
  const scoreEl = document.getElementById("score");
  scoreEl.innerHTML = `<p>${score}</p>`;
}

function onCompletedPath(indices) {
  if (indices.length < 3) return;

  const event = gameClient.onPathComplete(indices);
  switch (event.type) {
    case "unlisted":
      audio.play(Sounds.INVALID_WORD, { volume: .3});
      break;
    case "found":
      audio.play(Sounds.FOUND_WORD, { volume: .4});
      updateScore(event.score);
      break;
    case "refound":
      audio.play(Sounds.REFOUND_WORD, { volume: .5});
      break;
  };

}

/**
 *  applies grid element selection given { event: str, indices: int/list[int] }
 */
function applySelection(event) {
  switch (event.type) {
    case "add":
      selectCellByIndex(event.index);
      svg.updatePath(path.indices);
      gameClient.updatePath(path.indices);
      audio.play(Sounds.SELECT_CELL, { volume: .2});
      break;

    case "remove":
      deselectCellByIndex(event.index);
      svg.updatePath(path.indices);
      gameClient.updatePath(path.indices);
      audio.play(Sounds.DESELECT_CELL, { volume: .2});
      break;

    case "completed":
      for (let i = 0; i < 16; i++) deselectCellByIndex(i);
      onCompletedPath(event.indices);
      svg.updatePath(path.indices);
      gameClient.updatePath(path.indices);
      break;
  }
}

/**
 *  The user has selected an index from a pointermove event. What do?
 *  Note that index is null when the user moves the pointer in between cells.
 */
export function handleSelection(index) {
  if (index == null) return;

  if (index == -1) {
    applySelection(path.end());
    return;
  }

  if (path.canUndo(index)) {
    applySelection(path.removeLast());
    return;
  }

  if (path.isValidConnection(index) && !path.has(index)) {
    applySelection(path.add(index));
    return;
  }
}

/**
 *  TODO: move gameClient onCompletedPath logic out of gameClient?
 *  I want to have the sounds here, but I need to know if the word is correct or not.
 *  Could also have an event based return
 */
function onPointerStart(event) {
  const index = getCellFromPointerEvent(event);
  handleSelection(index);
}

function onPointerMove(event) {
  const index = getCellFromPointerEvent(event);
  handleSelection(index);
}

function onPointerEnd(event) {
  handleSelection(-1);
}

/**
 *  Creates a grid from a grid string, appends to DOM div gridContainer
 *  Adds event listeners for the pointer to select.
 */
export function createGrid(gridStr) {
  const gridArr = [...gridStr];
  const gridContainer = grid.createGridHTML(gridArr);
  setCopyLink();
  grid.measureGrid(gridContainer);
  document.getElementById("score").classList.add("animateIn");

  // These things need to be set AFTER grid HTML is created.
  const wrapperRect = gridContainer.getBoundingClientRect();
  getCellFromPointerEvent = (event) => {
    const px = event.clientX - wrapperRect.left;
    const py = event.clientY - wrapperRect.top;
    return grid.getCellAtPoint(px, py);
  };
  svg.createSelectionPath(wrapperRect.width, wrapperRect.height);
  grid.setHitRadius(wrapperRect.width / 8.);

  // Listeners
  gridContainer.addEventListener("pointerdown", onPointerStart);
  gridContainer.addEventListener("pointerup", onPointerEnd);
  gridContainer.addEventListener("pointermove", onPointerMove);
  gridContainer.addEventListener("pointercancel", onPointerEnd);

}
